import { render, staticRenderFns } from "./SidebarRow.vue?vue&type=template&id=72de7ff4&scoped=true&"
import script from "./SidebarRow.vue?vue&type=script&lang=js&"
export * from "./SidebarRow.vue?vue&type=script&lang=js&"
import style0 from "./SidebarRow.vue?vue&type=style&index=0&id=72de7ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de7ff4",
  null
  
)

export default component.exports